import { useEffect, useRef } from "react";
import "./reactionBlast.css";

const SPARKS = ["#FFD166", "#FF6A3D", "#FF3B5C", "#7FE7FF", "#C77DFF"];
const rnd = (a, b) => a + Math.random() * (b - a);

/** Esplosione a pieno schermo della reazione: shockwave + coriandoli emoji + scintille su canvas. */
export const ReactionBlast = ({ emoji, onDone }) => {
  const canvasRef = useRef(null);
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const w = canvas.clientWidth || window.innerWidth;
    const h = canvas.clientHeight || window.innerHeight;
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);

    const isAde = emoji === "ADE_LIKE";
    const sprite = isAde ? new Image() : null;
    if (sprite) sprite.src = "/images/ade-logo-tight.png";

    const cx = w / 2;
    const cy = h * 0.52;
    const parts = [];
    for (let i = 0; i < 56; i++) {
      const a = rnd(0, Math.PI * 2);
      const sp = rnd(3.2, 11);
      parts.push({ g: 1, x: cx, y: cy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - rnd(1, 4.5),
        size: rnd(18, 46), rot: rnd(0, 6.3), vr: rnd(-0.2, 0.2), life: 1, decay: rnd(0.008, 0.014) });
    }
    for (let i = 0; i < 110; i++) {
      const a = rnd(0, Math.PI * 2);
      const sp = rnd(4, 18);
      parts.push({ g: 0, x: cx, y: cy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp,
        size: rnd(1.6, 4.4), color: SPARKS[i % SPARKS.length], life: 1, decay: rnd(0.014, 0.026) });
    }

    let raf;
    const t0 = performance.now();
    let last = t0;
    const loop = (t) => {
      const dt = Math.min(2.6, (t - last) / 16.67);
      last = t;
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = "lighter";
      for (const p of parts) {
        p.life -= p.decay * dt;
        if (p.life <= 0) continue;
        p.vy += (p.g ? 0.3 : 0.14) * dt;
        p.vx *= 0.984;
        p.vy *= 0.984;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        ctx.globalAlpha = Math.max(0, Math.min(1, p.life));
        if (!p.g) {
          ctx.strokeStyle = p.color;
          ctx.lineWidth = p.size;
          ctx.lineCap = "round";
          ctx.beginPath();
          ctx.moveTo(p.x, p.y);
          ctx.lineTo(p.x - p.vx * 1.6, p.y - p.vy * 1.6);
          ctx.stroke();
        } else {
          p.rot += p.vr * dt;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          if (isAde && sprite.complete) {
            ctx.drawImage(sprite, -p.size / 2, -p.size * 0.44, p.size, p.size * 0.88);
          } else {
            ctx.globalCompositeOperation = "source-over";
            ctx.font = `${p.size}px system-ui, "Apple Color Emoji", sans-serif`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(emoji, 0, 0);
            ctx.globalCompositeOperation = "lighter";
          }
          ctx.restore();
        }
      }
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = "source-over";
      if (t - t0 < 2200) raf = requestAnimationFrame(loop);
      else doneRef.current?.();
    };
    raf = requestAnimationFrame(loop);
    const safety = setTimeout(() => doneRef.current?.(), 2900);
    return () => { cancelAnimationFrame(raf); clearTimeout(safety); };
  }, [emoji]);

  return (
    <div className="rb-root" data-testid="story-reaction-blast">
      <div className="rb-flash" />
      <span className="rb-ring" />
      <span className="rb-ring rb-ring-2" />
      <span className="rb-ring rb-ring-3" />
      <canvas ref={canvasRef} className="rb-canvas" />
      <div className="rb-core">
        {emoji === "ADE_LIKE"
          ? <img src="/images/ade-logo-tight.png" alt="" />
          : <span>{emoji}</span>}
      </div>
      <span className="rb-label">Reazione inviata</span>
    </div>
  );
};

export default ReactionBlast;
